import React from "react";
import { Form, Alert } from "antd";
import { withNamespaces } from "react-i18next";

class Consent extends React.Component {
  render() {
    return (
      <div className="form-group">
        <div className="form-group-details">
          <h4>{this.props.i18n.t('NamespaceConsentFormError:Consent Process - Error occured')}</h4>
          <Alert
            message={this.props.i18n.t("Error")}
            style={{ textAlign: "left" }}
            description={this.props.i18n.t('NamespaceConsentFormError:Consent document already signed or link has expired.')}
            type="error"
            showIcon
          />
        </div>
      </div>
    );
  }
}

const ConsentForm = Form.create()(withNamespaces()(Consent));

export default ConsentForm;



// WEBPACK FOOTER //
// ./src/components/ConsentError/ConsentFormError.js